import { Page } from '@ui/themed';
import { t } from 'i18next';
import { useEnv } from '../../../context/env-context';
import { useHandlers, withPageProviders } from '../../../context/page-context';
import type { I18nPrefix } from '../../../i18n/prefix';
import { ConfigurationsCard } from '../components/configurations-card';
import { PlatformForm } from '../components/platform-form';
import { METAFIELDS_PATH, PLATFORM_DOCS_URLS, supportsMetafields } from '../constants';

const PAGE = 'features:platform.pages.platform_page' satisfies I18nPrefix;

export const PlatformPage = withPageProviders(PlatformPageContent);

function PlatformPageContent() {
  const env = useEnv();
  const { navigationHandler } = useHandlers();

  return (
    <Page
      title={t(`${PAGE}.header.title`)}
      description={t(`${PAGE}.header.description`)}
      learnMoreUrl={PLATFORM_DOCS_URLS.learnMore}
    >
      <PlatformForm />

      {supportsMetafields(env.connected_platform) && (
        <ConfigurationsCard
          onConfigureMetafields={() => navigationHandler.navigate(METAFIELDS_PATH)}
        />
      )}
    </Page>
  );
}
